{
	"v": "5.6.6",
	"ip": 0,
	"op": 180,
	"fr": 60,
	"w": 24,
	"h": 24,
	"layers": [
		{
			"ind": 4497,
			"nm": "surface27551",
			"ao": 0,
			"ip": 0,
			"op": 264,
			"st": 0,
			"ty": 4,
			"ks": {
				"ty": "tr",
				"o": { "k": 100 },
				"r": { "k": 0 },
				"p": { "k": [0, 0] },
				"a": { "k": [0, 0] },
				"s": { "k": [133.33, 133.33] },
				"sk": { "k": 0 },
				"sa": { "k": 0 }
			},
			"shapes": [
				{
					"ty": "gr",
					"hd": false,
					"nm": "surface27551",
					"it": [
						{
							"ty": "gr",
							"hd": false,
							"it": [
								{
									"ty": "sh",
									"ks": {
										"k": {
											"i": [
												[0, 0],
												[0, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[12, 16],
												[12.01, 16]
											],
											"c": false
										}
									}
								},
								{
									"ty": "st",
									"lc": 2,
									"lj": 2,
									"ml": 4,
									"o": { "k": 100 },
									"w": { "k": 1.5 },
									"c": { "k": [0.8941176470588236, 0.5098039215686274, 0.4745098039215686, 1] },
									"hd": false
								},
								{
									"ty": "tr",
									"o": { "k": 100 },
									"r": { "k": 0 },
									"p": { "k": [0, 0] },
									"a": { "k": [0, 0] },
									"s": { "k": [75, 75] },
									"sk": { "k": 0 },
									"sa": { "k": 0 },
									"hd": false
								}
							]
						},
						{
							"ty": "gr",
							"hd": false,
							"it": [
								{
									"ty": "sh",
									"ks": {
										"k": {
											"i": [
												[0, 0],
												[0, 0]
											],
											"o": [
												[0, 0],
												[0, 0]
											],
											"v": [
												[12, 8],
												[12, 12]
											],
											"c": false
										}
									}
								},
								{
									"ty": "st",
									"lc": 2,
									"lj": 2,
									"ml": 4,
									"o": { "k": 100 },
									"w": { "k": 1.5 },
									"c": { "k": [0.8941176470588236, 0.5098039215686274, 0.4745098039215686, 1] },
									"hd": false
								},
								{
									"ty": "tr",
									"o": { "k": 100 },
									"r": { "k": 0 },
									"p": { "k": [0, 0] },
									"a": { "k": [0, 0] },
									"s": { "k": [75, 75] },
									"sk": { "k": 0 },
									"sa": { "k": 0 },
									"hd": false
								}
							]
						},
						{
							"ty": "gr",
							"hd": false,
							"it": [
								{
									"ty": "sh",
									"ks": {
										"k": {
											"i": [
												[0, 0],
												[5.52, 0],
												[0, 5.52],
												[-5.52, 0],
												[0, -5.52]
											],
											"o": [
												[0, 5.52],
												[-5.52, 0],
												[0, -5.52],
												[5.52, 0],
												[0, 0]
											],
											"v": [
												[22, 12],
												[12, 22],
												[2, 12],
												[12, 2],
												[22, 12]
											],
											"c": false
										}
									}
								},
								{
									"ty": "st",
									"lc": 2,
									"lj": 2,
									"ml": 4,
									"o": { "k": 100 },
									"w": { "k": 1.5 },
									"c": { "k": [0.8941176470588236, 0.5098039215686274, 0.4745098039215686, 1] },
									"hd": false
								},
								{
									"ty": "tr",
									"o": { "k": 100 },
									"r": { "k": 0 },
									"p": { "k": [0, 0] },
									"a": { "k": [0, 0] },
									"s": { "k": [75, 75] },
									"sk": { "k": 0 },
									"sa": { "k": 0 },
									"hd": false
								}
							]
						},
						{
							"ty": "tr",
							"o": { "k": 100 },
							"r": { "k": 0 },
							"p": { "k": [0, 0] },
							"a": { "k": [0, 0] },
							"s": { "k": [100, 100] },
							"sk": { "k": 0 },
							"sa": { "k": 0 },
							"hd": false
						}
					]
				},
				{
					"ty": "tm",
					"s": { "a": 0, "k": 0, "ix": 1 },
					"e": {
						"a": 1,
						"k": [
							{ "i": { "x": [0.27], "y": [1] }, "o": { "x": [0.5], "y": [0] }, "t": 0, "s": [0] },
							{ "t": 66, "s": [100] }
						],
						"ix": 2
					},
					"o": { "a": 0, "k": 0, "ix": 3 },
					"m": 1,
					"ix": 2,
					"hd": false
				}
			]
		}
	],
	"meta": { "g": "LF SVG to Lottie" },
	"assets": []
}
